export default {
    ALL: 'ALL',
    CERTIFICATED_AND_BOOK: 'CERTIFICATED_AND_BOOK',
    DIVIDEND_REINVESTMENT: 'DIVIDEND_REINVESTMENT'
};
